import { routes } from '@/app/routing/router'
import { RewardPageView } from './view'

const currentRoute = routes.reward

const RewardPageRoute = {
  route: currentRoute,
  view: RewardPageView,
}

export { currentRoute, RewardPageRoute }
